<script>
export default {
  data () {
    return {
      successes: null,
      errors: null,
    }
  },

  props: {
    duration: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    min_value: {
      type: Number,
      default: 0
    },
    max_value: {
      type: Number,
      default: 1
    },
    percentage: {
      default: false
    },
  },

  computed: {
    totalPercent: function () {
      return Math.round((this.value-this.min_value)/(this.max_value-this.min_value)*100) + "%"
    },

    totalWidth: function () {
      return 'width: ' + this.totalPercent + ';'
    },

    description: function () {
      if(this.percentage) {
        return this.totalPercent
      }

      return this.value + ' / ' + this.max_value
    },
  }
}
</script>

<template>
  <div>
    <div class="rounded-lg w-full bg-gray-300 overflow-hidden">
      <div class="rounded-lg p-2 text-center text-white bg-gray-600"
        role="progressbar"
        :aria-valuenow="value"
        :aria-valuemin="min_value"
        :aria-valuemax="max_value"
        :style="totalWidth"
      >
      </div>
    </div>
    <div class="progress-description text-center">
      {{ description }}
    </div>
  </div>
</template>
